import { ApplicationController } from "../../../../../app/webpack_assets/support/application_controller"
import { setupModal } from "../../../../shared_assets/app/webpack_assets/shared/setup_modal"

export default class extends ApplicationController {
  connect() {
    setupModal("walls-create-post-modal")
  }
}
